<div class="form-header">
  To allow ConnectWise Manage Integrated Users to access Identify, select which users to enable access below.
</div>

<cw-ci-data-table #userDataTable
  tileTitle="Users Added"
  defaultSortField="firstName"
  hidePageSize="true"
  hideRefreshButton="true"
  hideWrapper="true"
  pageSize="8"
  skipInitialLoad="true"
  [showLoadingAlert]="false"
  [isSelectable]="isSelectable"
  (loadItemsHandler)="loadUsers($event)"
  [items]="userList"
  class="users-multiline"
  [emptyListOverlay]="emptyListOverlay">

  <ng-template #emptyListOverlay>
    <div *ngIf="!hasFailedToGetManageUsers" style="display:flex; flex-direction:column; align-items: center; justify-content: center;">
      <img style="padding-bottom:20px;" src="assets/icons/large/large_icon_company.svg">
      <h2>Save and Enable your Manage integration</h2>
      <div style="max-width:500px; padding-bottom:20px; text-align: center;">There are no Manage users for you to import.</div>
    </div>
    <div *ngIf="hasFailedToGetManageUsers" style="display:flex; flex-direction:column; align-items: center; justify-content: center;">
      <h2>Failed to connect to Manage instance</h2>
      <div style="max-width:500px; padding-bottom:20px; text-align: center;">Please check integration settings.</div>
    </div>
  </ng-template>

  <cw-ci-table-column columnName="firstName" columnTitle="First Name" sortField="firstName" searchField="firstName" filterType="text"></cw-ci-table-column>
  <cw-ci-table-column columnName="lastName" columnTitle="Last Name" sortField="lastName" searchField="lastName" filterType="text"></cw-ci-table-column>
  <cw-ci-table-column columnName="officeEmail" columnTitle="Email Address" sortField="officeEmail" searchField="officeEmail" filterType="text"></cw-ci-table-column>

  <cw-ci-table-column columnName="actions" columnTitle="User Access" [output]="actionTemplate"></cw-ci-table-column>
  <ng-template let-element #actionTemplate>
    <div class="action-template">
      <button *ngIf="!element.identifyUserId" mat-button type="button" color="primary" (click)="allowAccess(element)">ALLOW ACCESS</button>
      <button *ngIf="element.identifyUserId > 0" mat-button type="button" color="primary" (click)="revokeAccess(element)">REVOKE ACCESS</button>
    </div>
  </ng-template>
</cw-ci-data-table>
